import { makeAutoObservable } from 'mobx';
import { PersonalAssetOverviewDto } from '../../../../defs/api';

export class PersonalAssetOverviewMobxDto implements PersonalAssetOverviewDto {
    startDate: Date;

    valueSum: number;

    cashSum: number;

    assetsCount: number;

    portfolioId: string;

    currencyCode: string;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: PersonalAssetOverviewDto): PersonalAssetOverviewMobxDto {
        const mobxDto = new PersonalAssetOverviewMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: PersonalAssetOverviewDto[]): PersonalAssetOverviewMobxDto[] {
        const createdDtos: PersonalAssetOverviewMobxDto[] = [];
        dtos.forEach((dto) => {
            createdDtos.push(PersonalAssetOverviewMobxDto.create(dto));
        });

        return createdDtos;
    }
}
